import(/* webpackMode: "eager" */ "/vercel/path0/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Instrument_Sans\",\"arguments\":[{\"variable\":\"--instrument-sans\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"700\"],\"display\":\"swap\",\"preload\":true}],\"variableName\":\"instrumentsans\"}");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/css/plugins.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/css/style.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/css/profile.css");
